import { render, staticRenderFns } from "./blog-7.vue?vue&type=template&id=145405de&scoped=true"
import script from "./blog-7.vue?vue&type=script&lang=js"
export * from "./blog-7.vue?vue&type=script&lang=js"
import style0 from "./blog-7.vue?vue&type=style&index=0&id=145405de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145405de",
  null
  
)

export default component.exports